export const WHITELIST_ABI = [
  {
    'inputs': [],
    'stateMutability': 'nonpayable',
    'type': 'constructor'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'authority',
        'type': 'address'
      }
    ],
    'name': 'AccessManagedInvalidAuthority',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'caller',
        'type': 'address'
      },
      {
        'internalType': 'uint32',
        'name': 'delay',
        'type': 'uint32'
      }
    ],
    'name': 'AccessManagedRequiredDelay',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'caller',
        'type': 'address'
      }
    ],
    'name': 'AccessManagedUnauthorized',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'target',
        'type': 'address'
      }
    ],
    'name': 'AddressEmptyCode',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'account',
        'type': 'address'
      }
    ],
    'name': 'AlreadyAllowlisted',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'implementation',
        'type': 'address'
      }
    ],
    'name': 'ERC1967InvalidImplementation',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'ERC1967NonPayable',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'FailedCall',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'InvalidInitialization',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'account',
        'type': 'address'
      }
    ],
    'name': 'NotAllowlisted',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'NotInitializing',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'UUPSUnauthorizedCallContext',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'bytes32',
        'name': 'slot',
        'type': 'bytes32'
      }
    ],
    'name': 'UUPSUnsupportedProxiableUUID',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'ZeroAddress',
    'type': 'error'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'account',
        'type': 'address'
      }
    ],
    'name': 'AddedToAllowlist',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': false,
        'internalType': 'address',
        'name': 'authority',
        'type': 'address'
      }
    ],
    'name': 'AuthorityUpdated',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': false,
        'internalType': 'uint64',
        'name': 'version',
        'type': 'uint64'
      }
    ],
    'name': 'Initialized',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'account',
        'type': 'address'
      }
    ],
    'name': 'RemovedFromAllowlist',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'implementation',
        'type': 'address'
      }
    ],
    'name': 'Upgraded',
    'type': 'event'
  },
  {
    'inputs': [],
    'name': 'UPGRADE_INTERFACE_VERSION',
    'outputs': [
      {
        'internalType': 'string',
        'name': '',
        'type': 'string'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'account',
        'type': 'address'
      }
    ],
    'name': 'add',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address[]',
        'name': 'accounts',
        'type': 'address[]'
      }
    ],
    'name': 'addBatch',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'authority',
    'outputs': [
      {
        'internalType': 'address',
        'name': '',
        'type': 'address'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': '_accessManager',
        'type': 'address'
      },
      {
        'internalType': 'contract ISanctionsList',
        'name': '_sanctionsList',
        'type': 'address'
      }
    ],
    'name': 'initialize',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': '',
        'type': 'address'
      }
    ],
    'name': 'isAllowlisted',
    'outputs': [
      {
        'internalType': 'bool',
        'name': '',
        'type': 'bool'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'isConsumingScheduledOp',
    'outputs': [
      {
        'internalType': 'bytes4',
        'name': '',
        'type': 'bytes4'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'proxiableUUID',
    'outputs': [
      {
        'internalType': 'bytes32',
        'name': '',
        'type': 'bytes32'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'account',
        'type': 'address'
      }
    ],
    'name': 'remove',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address[]',
        'name': 'accounts',
        'type': 'address[]'
      }
    ],
    'name': 'removeBatch',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'sanctionsList',
    'outputs': [
      {
        'internalType': 'contract ISanctionsList',
        'name': '',
        'type': 'address'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'newAuthority',
        'type': 'address'
      }
    ],
    'name': 'setAuthority',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'newImplementation',
        'type': 'address'
      },
      {
        'internalType': 'bytes',
        'name': 'data',
        'type': 'bytes'
      }
    ],
    'name': 'upgradeToAndCall',
    'outputs': [],
    'stateMutability': 'payable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'account',
        'type': 'address'
      }
    ],
    'name': 'verifyAccount',
    'outputs': [
      {
        'internalType': 'bool',
        'name': '',
        'type': 'bool'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  }
] as const;
